import * as React from "react";

const TiktokIcon = (props) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM15.85 8.48C16.45 8.89 17.1 9.18 17.79 9.32V11.56C16.62 11.49 15.51 10.92 14.89 10.03V15.54C14.89 17.16 13.57 18.5 11.96 18.5C10.34 18.5 9 17.16 9 15.54C9 13.92 10.34 12.58 11.96 12.58C12.17 12.58 12.37 12.61 12.56 12.66V14.42C12.47 14.39 12.37 14.38 12.26 14.38C11.61 14.38 11.07 14.92 11.07 15.54C11.07 16.16 11.61 16.7 12.26 16.7C12.89 16.7 13.45 16.17 13.45 15.54V7H15.12C15.17 7.51 15.44 8.02 15.85 8.48Z"
            fill="#000000"
        />
    </svg>
);

export default TiktokIcon;
